export default "__VITE_ASSET__420181b0__"